import { IVersionedChoice, PropertySheet, PropertySheetCategory, TypedCardElementPeer } from "adaptivecards-designer";
import {  getPropertyEditorInstance, PickerBase, PropertyKeys } from "./PickerBase";
import {  removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";

export class StatusPicker extends PickerBase{
    static readonly JsonTypeName = "Status";
    static readonly ElementId = "Ticket.Status";
    static readonly defaultLabel = "Status";
    static pickerChoices: any[];

    protected internalRender(): HTMLElement | undefined {
        this.id = StatusPicker.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = StatusPicker.defaultLabel;

        if(StatusPicker.pickerChoices){
            this.displayChoices = StatusPicker.pickerChoices;
        }
        
        return super.internalRender();
    }
    
    getJsonTypeName(): string {
        return StatusPicker.JsonTypeName;
    }
}

export class StatusPickerPeer extends TypedCardElementPeer<StatusPicker> {
    static displayLabelProperty = getPropertyEditorInstance(StatusPicker.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(StatusPicker.ElementId, PropertyKeys.requireField);
    static dataSourceProperty = getPropertyEditorInstance(StatusPicker.ElementId, PropertyKeys.dataSource, []);

    static updateChoices(choices: IVersionedChoice[]) {
        this.dataSourceProperty = getPropertyEditorInstance(StatusPicker.ElementId, PropertyKeys.dataSource, choices);
    }

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);
        
        propertySheet.add(
            defaultCategory,
            StatusPickerPeer.idProperty,
            StatusPickerPeer.displayLabelProperty,
            StatusPickerPeer.requireFieldProperty,
            StatusPickerPeer.dataSourceProperty);
    
    }
}
